let state = {
  // 模板 别删
  // Classify:null,//分类数据
  // Classifyname:null,//分类数据左侧名称
  homeBanner: null,
  TeacherBanner: null, //家教轮播图
  teacherTop: null, //家教排行
  housekeepingbanner: null, //家政轮播图
  HomeWorker: null, //家政员工信息
  RepairComment: null, //维修评论
  Repair: null, //维修列表
  Water: null, //水站列表
  city: "北京" //城市
};
export default state;



// WEBPACK FOOTER //
// ./src/store/state.js